<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <!--  <i class="material-icons">perm_identity</i> -->
              <img
                class="img--icon"
                [src]="userImgUrl"
                (click)="openModalImg('imgUser')"
              />
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              {{ id ? "Update" : "New" }} User
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="firstname"
                      >Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstname"
                      formControlName="firstname"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('firstname')"
                    >
                      The name is required
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="lastname"
                      >Last Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="lastname"
                      formControlName="lastname"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      The last name is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="identification"
                      >Identification</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="identification"
                      formControlName="identification"
                      [readOnly]="id"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="rut">S.S / RUT</label>
                    <input
                      type="text"
                      class="form-control"
                      id="rut"
                      formControlName="rut"
                      [readOnly]="id"
                    />
                  </div>
                </div>
              </div> -->

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="indicative"
                      >Indicative</label
                    >
                    <select
                      class="form-control select"
                      id="indicative"
                      formControlName="indicative"
                    >
                      <option value="" disabled>Select a indicative</option>
                      <option *ngFor="let item of indicatives" [value]="item">
                        {{ item }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('indicative')"
                    >
                      Indicative is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="phone">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      (input)="formatPhone($event)"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      Phone is required
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="address"
                      >Address</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      formControlName="address"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      Address is required
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="apt">Apt</label>
                    <input
                      type="text"
                      class="form-control"
                      id="apt"
                      formControlName="apt"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('city')"
                    >
                      City is required
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="state">State</label>
                    <input
                      type="text"
                      class="form-control"
                      id="state"
                      formControlName="state"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('state')"
                    >
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="country"
                      >Country</label
                    >
                    <select
                      class="form-control select"
                      id="country"
                      formControlName="country"
                    >
                      <option value="" disabled>Select a country</option>
                      <option *ngFor="let item of countries" [value]="item">
                        {{ item }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('country')"
                    >
                      Country is required
                    </div>
                  </div>
                </div>
              </div>
 -->

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="username"
                      >Email</label
                    >
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                        [readOnly]="!update"
                      />
                      <button
                        class="btn btn-sm btn-outline-dark"
                        type="button"
                        (click)="openEmail(form.get('username')?.value)"
                        title="Send email"
                      >
                        <i class="fas fa-envelope"></i>
                      </button>
                    </div>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('username')"
                    >
                      The email is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="role">Role</label>
                    <select
                      class="form-control select"
                      id="role"
                      formControlName="role"
                      [ngClass]="{ disabled__select: !update }"
                    >
                      <option value="" disabled>Select a role</option>
                      <option *ngFor="let item of roles" [value]="item._id">
                        {{ item.name }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('role')"
                    >
                      The role is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="department"
                      >Department</label
                    >
                    <select
                      class="form-control select"
                      id="department"
                      formControlName="department"
                      [ngClass]="{'disabled__select' : !update}"
                    >
                      <option value="" disabled>Select a department</option>
                      <option *ngFor="let item of departments" [value]="item">
                        {{ item }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('department')"
                    >
                      The department is required
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row text-center">
                <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="password"
                      >Password</label
                    >
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      formControlName="password"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      Password is required
                    </div>
                  </div>
                </div> -->
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="custom-control custom-switch mt-4">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid || isLoading"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>

              <div class="clearfix"></div>
            </form>

            <!-- Modal imgs-->
            <div
              class="modal fade"
              tabindex="-1"
              [ngClass]="{ 'show d-block': showModalImg }"
              style="background-color: rgba(0, 0, 0, 0.5)"
            >
              <!-- style="background-color: rgba(0,0,0,0.5);" -->
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header modal-close">
                    <button
                      type="button"
                      class="btn btn-link btn-sm btn-close"
                      (click)="closeModalImg()"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img [src]="imgModal" class="modal--imgs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-avatar"></div>
          <div class="card-body">
            <h6 class="card-category text-gray">Perfil de usuario</h6>
            <h4 class="card-title">
              {{ form.get("firstname")?.value }}
              {{ form.get("lastname")?.value }}
            </h4>
            <p class="card-description">
              Aquí puedes editar los datos del usuario. Los cambios se
              reflejarán en el sistema.
            </p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
